import { useResponsivePropertyModal } from 'presentation/components/PropertyModal/PropertyModal.hooks'

export const usePropModalFromPreviewScreen = () =>
  useResponsivePropertyModal({
    backLabel: 'Back to List Builder Preview',
  })
